<div class="row dual-list">
  <div class="col-left no-padding-left">
    <p><strong>{{dataSourceName()}}</strong></p>

    <div class="box-selection">
      @if (dataSource()) {
        <mat-selection-list #dataSourceSelection>
          @for (item of dataSource(); track item) {
            <mat-list-option [value]='item'>
              {{item.display}}
            </mat-list-option>
          }
        </mat-selection-list>
      }

      @if (!dataSource().length) {
        <p>No items</p>
      }
    </div>
  </div>

  <div class="col-mid">
    <div class="box-buttons">
      <div class="row">
        <button mat-raised-button (click)="moveAllItemToSelected()" title="Select all" type="button">
          <mat-icon>last_page</mat-icon>
        </button>

        <button mat-raised-button (click)="moveItemToSelected()" title="Select" type="button">
          <mat-icon>arrow_forward</mat-icon>
        </button>

        <button mat-raised-button (click)="moveItemToDataSource()" title="Remove" type="button">
          <mat-icon>arrow_back</mat-icon>
        </button>

        <button mat-raised-button (click)="moveAllItemToDataSource()" title="Remove all" type="button">
          <mat-icon>first_page</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="col-right no-padding-right">
    <p><strong>{{selectedItemName()}}</strong></p>

    <div class="box-selection">
      @if (selectedItems) {
        <mat-selection-list #selectedItemSelection>
          @for (item of selectedItems; track item) {
            <mat-list-option [value]='item'>
              {{item.display}}
            </mat-list-option>
          }
        </mat-selection-list>
      }

      @if (!selectedItems.length) {
        <p>No items</p>
      }
    </div>
  </div>
</div>
